/** Audio procedural (sin archivos externos) — CC0 por implementación propia. */
export class Soundscape {
  private ctx: AudioContext | null = null;
  private enabled = false;
  private ambientOsc: OscillatorNode | null = null;
  private ringTimer: ReturnType<typeof setInterval> | null = null;

  async unlock(): Promise<void> {
    if (!this.ctx) {
      this.ctx = new AudioContext();
    }
    if (this.ctx.state === 'suspended') {
      await this.ctx.resume();
    }
  }

  setEnabled(on: boolean): void {
    this.enabled = on;
    if (!on) {
      this.stopAmbient();
      this.stopRing();
      return;
    }
    if (this.ctx?.state === 'running') {
      this.startAmbient();
    }
  }

  startAmbient(): void {
    if (!this.enabled || !this.ctx || this.ambientOsc) return;
    const ctx = this.ctx;
    const osc = ctx.createOscillator();
    osc.type = 'sine';
    osc.frequency.value = 110;
    const gain = ctx.createGain();
    gain.gain.value = 0.012;
    const lfo = ctx.createOscillator();
    lfo.frequency.value = 0.15;
    const lfoGain = ctx.createGain();
    lfoGain.gain.value = 0.006;
    lfo.connect(lfoGain);
    lfoGain.connect(gain.gain);
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.start();
    lfo.start();
    this.ambientOsc = osc;
  }

  stopAmbient(): void {
    this.ambientOsc?.stop();
    this.ambientOsc = null;
  }

  playPhoneRing(): void {
    if (!this.enabled || !this.ctx) return;
    this.stopRing();
    const ctx = this.ctx;
    this.ringTimer = setInterval(() => {
      const o = ctx.createOscillator();
      const g = ctx.createGain();
      o.frequency.value = 880;
      g.gain.value = 0.04;
      o.connect(g);
      g.connect(ctx.destination);
      o.start();
      g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + 0.35);
      o.stop(ctx.currentTime + 0.36);
    }, 900);
  }

  stopRing(): void {
    if (this.ringTimer) clearInterval(this.ringTimer);
    this.ringTimer = null;
  }

  playClick(): void {
    if (!this.enabled || !this.ctx) return;
    const ctx = this.ctx;
    const o = ctx.createOscillator();
    const g = ctx.createGain();
    o.frequency.value = 520;
    g.gain.value = 0.03;
    o.connect(g);
    g.connect(ctx.destination);
    o.start();
    g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + 0.08);
    o.stop(ctx.currentTime + 0.09);
  }

  destroy(): void {
    this.setEnabled(false);
    this.ctx?.close();
    this.ctx = null;
  }
}
